import React from "react";

import Feature from "./Feature";

import { StyledFeatures } from "./style";

const Features = ({ features }) =>
  features?.length > 0 && (
    <StyledFeatures>
      {features?.map((feature, index) => (
        <Feature key={index + Math.random().toString()} {...feature} />
      ))}
    </StyledFeatures>
  );

export default Features;
